import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PaymentMethodFilter from "../../search/paymentMethodFilter";
import { cleanSpecialCharacters } from "../../../extras";
import MoneyTextField from "../../Inputs/MoneyTextField";
import { LightGreyBox } from "../../styled";

export default function PaymentMethodTransferDialog({
  open,
  payment,
  onClose,
  onConfirm,
}) {
  const [amount, setAmount] = useState("");
  const [toMethod, setToMethod] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setAmount("");
  }, [payment]);

  const handleFilterChange = (method) => {
    setToMethod(method.value);
  };

  const handleConfirm = () => {
    if (!amount.trim()) {
      setError(true);
      return;
    }
    setError(false);

    onConfirm({
      amount_cents: parseFloat(amount) * 100,
      from_payment_method: payment.payment_method,
      to_payment_method: toMethod,
      onClose,
    });
    setAmount("");
  };

  return (
    <Dialog open={open} onClose={onClose} sx={{ zIndex: 999999 }}>
      <DialogTitle>Transferir Valores</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body1">De</Typography>
          <LightGreyBox>
            <Typography variant="body1">
              {cleanSpecialCharacters(payment?.payment_method)}
            </Typography>
          </LightGreyBox>

          <Typography variant="body1" sx={{ mb: 0 }}>
            Para
          </Typography>
          <PaymentMethodFilter onFilterChange={handleFilterChange} />

          <Typography variant="body1">Quantidade</Typography>
          <MoneyTextField
            label="Digite o valor"
            fullWidth
            value={amount}
            setValue={(val) => setAmount(val)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
